import { heatRank } from "@/mocks/homeData";
import SectionHead from "./SectionHead";

export default function HeatRank() {
  return (
    <section id="rank" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 py-10 md:px-6 md:py-14">
      <SectionHead
        kicker="fire-line"
        title="今日热度榜 · 谁在刷屏"
        sub="按全站阅读与讨论热度实时排序，榜单越靠上，围观热度越高。"
      />

      <div className="grid grid-cols-1 gap-2 lg:grid-cols-2">
        {heatRank.map((it, i) => {
          const top3 = i < 3;
          return (
            <a
              key={it.title}
              href="#feed"
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-3 py-2.5 transition-colors hover:border-accent-300 hover:bg-accent-50/40 md:gap-4 md:px-4"
            >
              <span
                className={
                  "flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-display text-base font-bold " +
                  (top3 ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-700")
                }
              >
                {i + 1}
              </span>

              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-foreground-950 md:text-[15px]">
                  {it.title}
                </p>
                <div className="mt-1.5 flex items-center gap-2">
                  <span className="inline-flex items-center rounded bg-background-200/70 px-1.5 py-0.5 text-[11px] text-foreground-600">
                    {it.cat}
                  </span>
                  <span className="flex items-center gap-1 text-[11px] text-foreground-400">
                    <i className="ri-eye-line" aria-hidden="true" />
                    {it.views} 浏览
                  </span>
                </div>
              </div>

              {/* heat meter */}
              <div className="hidden w-24 shrink-0 flex-col items-end gap-1 sm:flex">
                <div className="flex items-center gap-1">
                  <i className="ri-fire-fill text-accent-500" aria-hidden="true" />
                  <span className="font-display text-sm font-semibold text-accent-700">{it.heat}</span>
                </div>
                <div className="h-1 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-accent-500"
                    style={{ width: `${it.heat}%` }}
                  />
                </div>
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
}